import React from 'react';
import styled from 'styled-components';
import { Paper, Grid, Container, Divider } from '@material-ui/core';
import { LongBody, ShortBody } from 'components/Typography';
import breakpoints from 'utils/breakpoints';

export const StyledContainer = styled(Container)`
  && {
    padding-top: 30px;
    padding-bottom: 20vh;
    .MuiFormControlLabel-label {
      font-size: 14px;
      font-weight: 400;
    }
    .MuiRadio-colorSecondary.Mui-checked {
      color: #32c284;
    }
    .MuiSwitch-colorSecondary.Mui-checked {
      color: #32c284;
    }
    .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
      background-color: #32c284;
    }
  }
`;

export const StyledPaper = styled(Paper)`
  && {
    border-radius: 8px;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 24px 0 rgba(0, 0, 0, 0.08);
    margin-bottom: 32px;
  }
`;

export const StyledDiv = styled.div`
  && {
    border-radius: 100%;
    height: 40px;
    width: 40px;
    margin-bottom: 20px;
    background-color: #e8f3f8;
    > img {
      margin: 8px;
    }
  }
`;
export const StyledLongBody = styled(LongBody)`
  && {
    margin-bottom: 0px;
  }
`;

export const ActiveNotificationWrapper = styled(Grid)`
  padding: 10px 25px;
  border-radius: 10px;
  border: 1px solid #e6e6e6;
  margin-bottom: 40px;

  h6 {
    margin-bottom: 0px;
  }
`;

export const HeaderWrapper = styled(({ reverse, ...otherProps }) => (
  <div {...otherProps} />
))`
  && {
    img {
      margin-right: ${(props) => (props.reverse ? '0px' : '12px')};
      margin-left: ${(props) => (props.reverse ? '12px' : '0px')};
    }
    h5 {
      margin-bottom: 0;
    }
    margin-bottom: 15px;
  }
`;

export const StyledShortBody = styled(ShortBody)`
  && {
    font-size: 13px;
    margin-bottom: 0px;
    margin-left: 0px;
    @media (max-width: ${breakpoints.xs}) {
      margin-left: -13px;
      padding: 0px;
    }
  }
`;

export const StyledDivider = styled(Divider)`
  && {
    margin-top: 65px;
    margin-bottom: 16px;
  }
`;
